module.exports = __webpack_public_path__ + "static/7-33821b680377eea7c06e2b87537b8f6b.jpeg";